import {
  ContentLayout,
  GlobalPageContent,
} from '@silvertours/common-landingpages-view';
import {
  BenefitsLegacy,
  ContentArticle,
  StageLegacy,
} from '@silvertours/front-features';

import { ThemeProvider } from '@emotion/react';
import { Theme } from '@silvertours/front-shared';
import { useTranslations } from 'next-intl';
import { Body } from '../body';

const GlobalContent = ({
  content: {
    globalRating,
    links,
    stage,
    textContent: { primaryHeadline },
  },
  ...commonProps
}: ContentLayout<GlobalPageContent>) => {
  const t = useTranslations('features');
  const translations = t.raw('article' as any);
  return (
    <Body
      title={primaryHeadline}
      stage={<StageLegacy.Stage content={stage.content} />}
      content={({ containerModule }) => [
        containerModule(
          'usp',
          <BenefitsLegacy.Usp rating={globalRating.content} />,
        ),

        containerModule(
          'linkLists',
          <ThemeProvider theme={Theme.defaultTheme}>
            <ContentArticle
              modules={links.content ?? []}
              translations={translations}
            />
          </ThemeProvider>,
          !!links.content.length,
        ),
      ]}
      {...commonProps}
    />
  );
};

export { GlobalContent };
